<template>
  <hm-content title="">
    <div class="flex item-center flex-end mb10 pointer">
      <span @click="batchSetting">
        <span style="margin-right: 5px" class="hmicon icon-xitong blue"></span
        >批量标记为已处理
      </span>
    </div>
    <el-table
      stripe
      ref="table"
      :data="list"
      @selection-change="getChecked"
      style="width: 100%"
      id="table"
      size="small"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column
        type="index"
        label="序号"
        :index="(index) => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="spuName"
        label="计划名称"
        show-overflow-tooltip
        width="180"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="goodsSn"
        label="目标人群"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="goodsSn"
        label="推送状态"
      >
        <template slot-scope="scope">
          <div class="danger">推送失败</div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="goodsSn"
        label="原因"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="goodsSn"
        label="失败时间"
      ></el-table-column>

      <el-table-column header-align="center" align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="small" class="blue" type="text"
            >标记为已处理</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      checkedRowList: [],
      searchCondition: {},
      total: 0,
      list: [{}],
      pageSize: 10,
      currentPage: 1,
      row: JSON.parse(this.$route.query.row)
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    batchSetting() {
      if (this.checkedRowList.length) {
        // this.dialogVisibleBatch = true;
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    getChecked(selection) {
      this.checkedRowList = selection;
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      //   if (this.sort.order === "descending") {
      //     searchCondition.sortBy = "desc";
      //   } else if (this.sort.order === "ascending") {
      //     searchCondition.sortBy = "asc";
      //   }

      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>
<style lang='scss' scoped>
</style>
